import { CButton, CInput } from '@app/components/Common';
import { COLORS } from '@app/constants';
import { useToken } from '@app/hooks';
import { useMyProfile } from '@app/hooks/user/myprofile';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Text, View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import API from '@utils/api';
import { styled } from 'styled-components';
import { message } from 'antd';

const ProfileEditBody = ({ closeModal }: any) => {
  const { data: token } = useToken();
  const { mutate } = useMyProfile();
  const { gray, textw, PrimaryInputBg, PrimaryInputBorder } = useContext(ThemeContext).theme.COLORS;
  const [nickname, setNickName] = useState('');
  const { t } = useTranslation();

  const changeUsername = async () => {
    if (nickname?.length < 5) {
      message.error(`${t('usernameAtLeastFive')}`);
      return;
    }

    try {
      const res = await API.put('/user/my/nickname', `${token}`, {
        nickname: nickname,
      });
      if (res?.result?.success) {
        message.success(`${t('successfullyChangedNickname')}`);
        mutate(null);
        closeModal();
      } else {
        message.error(`${t('invalidError')}`);
      }
    } catch (e) {
      message.error(`${t('invalidError')}`);
    }
  };

  return (
    <ProfileEditBodyWrapper
      style={{
        gap: 8,
      }}
    >
      <View
        style={{
          width: '100%',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          marginTop: 10,
        }}
      >
        <Text size={14}>{t('changeUsername')}</Text>
        <CInput
          placeholder={t('edityourusername')}
          value={nickname}
          type={'text'}
          onClick={() => {}}
          onChange={(e: any) => {
            setNickName(e.target.value);
          }}
          vStyle={{ width: '100%' }}
          style={{
            flexDirection: 'row',
            marginTop: 10,
            width: '100%',
            justifyContent: 'space-between',
            padding: 8,
            borderRadius: 4,
            cursor: 'pointer',
            background: PrimaryInputBg,
            border: `1px solid ${PrimaryInputBorder}`,
            color: textw,
          }}
        />
      </View>

      <CButton
        title={t('confirm')}
        onClick={changeUsername}
        style={{
          background: COLORS.primary,
          color: COLORS.white,
          padding: '6px 12px',
          alignSelf: 'flex-end',
          cursor: 'pointer',
          borderRadius: 4,
        }}
      />
    </ProfileEditBodyWrapper>
  );
};

export default ProfileEditBody;

const ProfileEditBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
